import { Router, RouterConfiguration } from 'aurelia-router';
import { autoinject, PLATFORM, LogManager } from "aurelia-framework";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AuthenticateStep} from 'aurelia-authentication';
import 'syncfusion-javascript/Scripts/ej/web/ej.splitter.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.menu.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.tab.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.schedule.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.gantt.min';
import 'syncfusion-javascript/Scripts/ej/datavisualization/ej.chart.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.rte.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.datepicker.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.autocomplete.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.radiobutton.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.uploadbox.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.accordion.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.slider.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.progressbar.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.dropdownlist.min';
import 'syncfusion-javascript/Scripts/ej/web/ej.combobox.min';
import { AppEvents } from 'core/app-events';

@autoinject()
export class AppShell {
	toggleIsBusyIndicator(visiblity: boolean) {
		if (visiblity) {
			let obj = $("#login-root").data("ejWaitingPopup");
			if(obj) obj.show();
		}
		else {
			let obj = $("#login-root").data("ejWaitingPopup");
			if(obj) obj.hide();
		}
    }
	logger = LogManager.getLogger('App-Shell');
	router: Router;
    showIsBusySubscription: Subscription;

	constructor(private eventAggregator: EventAggregator) {

		this.showIsBusySubscription = this.eventAggregator.subscribe(AppEvents.ToggleIsBusyVisiblity, visiblity => {
			this.toggleIsBusyIndicator(visiblity);
		});
		//this.logger.info("Initializing Intercom");
		//(window as any).Intercom("boot", {
		//	app_id: "a352dw6f",
		//	hide_default_launcher: true,
		//	custom_launcher_selector: '#my_custom_link'
		//});
	}



	configureRouter(config: RouterConfiguration, router: Router) {
		config.title = 'Traken';
		config.addAuthorizeStep(AuthenticateStep); // Add a route filter so only authenticated 
		config.map([
			{ route: [''], redirect: 'app'},
			{ route: ['app'], name: 'app', moduleId: PLATFORM.moduleName('./app'), nav: false, auth: true },
			{ route: ['login'], name: 'login', moduleId: PLATFORM.moduleName('./account/login'), nav: false },
			{ route: ['logout'], name: 'logout', moduleId: PLATFORM.moduleName('./account/logout'), nav: false },
			{ route: ['register'], name: 'register', moduleId: PLATFORM.moduleName('./account/register'), title:'Sign Up', nav:false},


		]);

		this.router = router;
	}

	
	activate() {
		this.logger.info("activate");
		
		


	}
	

	
}